import EntriesSection from './EntriesSection';

export default EntriesSection;
